import React from "react";
import styled from "styled-components";
import Styles from "@themes/Styles";
import { FontSize } from "../../../themes/Fonts";
import LifeAtButton, { LifeAtButtonProps } from "../LifeAtButton";

const StyledButton = styled(LifeAtButton)`
    padding: 4px 3px;
    min-height: 28px;
    border-radius: ${Styles.borderRadiusSharp};
    background: ${(props) => props.theme.backgroundSpecial} !important;
    * {
        background: ${(props) => props.theme.backgroundSpecial} !important;
    }

    button {
        font-size: ${FontSize.normal};
    }

    &:hover {
        background-color: ${(props) => props.theme.hoverPrimary} !important;
        * {
            background: ${(props) => props.theme.hoverPrimary} !important;
        }
    }

    .lifeat-button-icon {
        display: flex;
    }
`;

interface LifeAtSecondaryButtonProps extends LifeAtButtonProps {
    className?: string;
}
export default function LifeAtSecondaryButton(props: LifeAtSecondaryButtonProps) {
    return <StyledButton className={`secondary-button ${props.className}`} {...props} />;
}
